import React from 'react';
import styles from './OrbitMaker.module.scss'
import Globe from '../OrbitElementsSimulator/Globe/Globe'

function OrbitMaker({orbits = [], doGlobe = true, doGroundData = true, doTrackers = true}) {
    return <div className={styles.OrbitMaker}>
        {doGlobe === true && <div className={styles.Globe}>
                <Globe orbits={orbits} ></Globe>
        </div>}
        {doGroundData === true && <div className={styles.GroundTrack}>

        </div>}
        {doTrackers === true && <div className={styles.Trackers}>
        </div>}
    </div>

}

export default OrbitMaker;
